module.exports = __webpack_public_path__ + "static/media/captivating-3.bb742b4e.png";